// src/utils/styleConstants.js

// Font Styles
export const fontStyles = [
  { font: "helvetica", size: 10.5, color: [0, 128, 0], fontWeight: "bold" },
  { font: "times", size: 11, color: [128, 0, 0], fontWeight: "bold" },
];

// Label Colors
export const labelColors = [
  "#191970",  // Midnight Blue
  "#006400",  // Dark Green
  "#B22222",  // Firebrick Red
  "#D35400",  // Shiny Burnt Orange

  "#DC143C",  // Crimson Red
];

// Value Colors
export const valueColors = [
  "#800080",  // Purple
  "#D35400" , // Shiny Burnt Orange


  "#00008B",  // Dark Blue
  "#006400",  // Dark Green
  "#4169E1",  // Royal Blue
];

// Line Colors
export const lineColors = [
  "#228B22",  // Forest Green
  "#FF1493",  // Deep Pink
  "#FFD700",  // Golden Yellow
  "#4682B4",  // Steel Blue
  "#D2691E",  // Chocolate Brown
];
